// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1x5Bm","loaderOuter":"PageOverlayLoader_loaderOuter__zpwwF"};